import React from 'react'
import ReactDOM from 'react-dom/client'
import Init from './Init'

ReactDOM.createRoot(document.getElementById('root')).render(<Init />)
